import React from "react";
import { Ban } from "lucide-react";
import AuthShell from "../../components/AuthShell/AuthShell";
import TextButton from "../../components/primitives/TextButton";
import { API_BASE_URL } from "../../config";
import "./auth.css";

function AccountSuspendedPage() {
    // Always go through BE logout: clears the session cookie and triggers
    // a full reload so AuthContext drops `suspended` and the user can land
    // on /login afresh (or sign in as a different account).
    const fullSignOut = () => {
        window.location.href = `${API_BASE_URL}/logout`;
    };
    return (
        <AuthShell
            eyebrow="Console / Suspended"
            title="Account suspended."
            lede="Your account has been disabled. If you believe this is a mistake, contact support."
        >
            <div className="auth-check auth-check--error">
                <div
                    className="auth-check__icon auth-check__icon--error"
                    aria-hidden="true"
                >
                    <Ban size={20} />
                </div>
            </div>
            <TextButton variant="primary" fullWidth onClick={fullSignOut}>
                Sign out
            </TextButton>
        </AuthShell>
    );
}

export default AccountSuspendedPage;
